// extracted by mini-css-extract-plugin
export default {"item":"PageLink_item__RGLpz","active":"PageLink_active__TZezF","editButton":"PageLink_editButton__3SESH"};